module.exports = __webpack_public_path__ + "img/moon.350e59cd.png";